<template>
  <div id="questionList" class="container">
    <v-container v-if="this.totalQuestions" class="mx-auto" fluid grid-list-xl>
      <div v-if="result">
        <shark-swim
          :enabled="
            result.finalScore > 95 &&
            this.totalQuestions > 30 &&
            this.mock.mode !== 1
          "
        />
      </div>
      <v-layout fill-height pa-3 row wrap>
        <v-pagination
          v-model="currentQuestion"
          :length="totalQuestions"
          :total-visible="5"
          style="width: auto"
        />
        <v-spacer />
        <mock-timer
          id="timer"
          :disabled="this.mock.mode === 1"
          :seconds="timeLeft"
          @timeOver="onTimeOver"
          @timeUpdate="onTimeUpdate"
        >
        </mock-timer>
        <v-btn
          v-if="!mockFinished && this.mock.mode === 2"
          :disabled="
            mockFinished || this.questions[this.currentQuestion - 1].finished
          "
          color="success"
          @click="finishMock(false)"
        >
          <v-icon>done_all</v-icon>
          <v-flex v-if="$vuetify.breakpoint.mdAndUp">Finalizar</v-flex>
        </v-btn>
      </v-layout>
      <v-container fluid grid-list-xl>
        <question
          :disabled="questions[currentQuestion - 1].finished"
          :loading="this.loading"
          :mode="this.mock.mode"
          :question="questions[currentQuestion - 1]"
          @checkAnswers="finishMock()"
        />
      </v-container>
    </v-container>
    <message-card
      v-if="this.totalQuestions === 0"
      :cta="{ title: 'Tentar outro critério', route: 'mocks.search' }"
      icon="/img/beer-mug.svg"
      subtitle="O critério aplicado não resultou em nenhuma questão"
      title="Está vazio aqui"
    >
    </message-card>

    <v-layout justify-center row>
      <v-dialog v-model="dialog" max-width="300" persistent>
        <v-card>
          <v-card-title class="headline"
            >Não está esquecendo de algo?</v-card-title
          >
          <v-card-text
            >Parece que você esqueceu de responder uma ou mais questões. O que
            você deseja fazer?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialog = false"
              >Revisar</v-btn
            >
            <v-btn color="red darken-1" text @click="finishMock(true)"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import QuestionFilter from "@/components/quiz/QuestionFilter";
import Question from "@/components/quiz/EventQuestion";
import MockService from "@/services/mocks.service";
import MockEnd from "./EventEnd";
import SharkSwim from "../../components/animation/SharkSwim";
import MessageCard from "../../components/widgets/card/MessageCard";
import MockTimer from "../../components/quiz/MockTimer";

export default {
  components: {
    MockTimer,
    MessageCard,
    SharkSwim,
    QuestionFilter,
    Question,
    MockEnd,
  },
  mounted() {},
  metaInfo() {
    return {
      title: "LS - Simulado de Questões de Certificação",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Resolva questões de testes ou simulados de questões de certificação",
        },
      ],
    };
  },
  data() {
    return {
      filter: {
        courses: [],
        topics: [],
        subjects: [],
      },
      answers: null,
      paused: false,
      dialog: false,
      currentQuestion: null,
      totalQuestions: null,
      option: null,
      loading: false,
      questions: {},
      mockFinished: false,
      mock: null,
      mockId: null,
      result: {
        finalScore: null,
      },
      timeLeft: 30 * 100,
    };
  },
  computed: {
    authenticated() {
      return this.$store.state.auth.user !== null;
    },
  },
  created() {
    this.loading = true;
    const query = this.$route.query;
    query.include = "questions";

    MockService.getEventMock(this.$route.params.id, query).then((resp) => {
      if (resp.data == 0) {
        window.getApp.sendSnackMessage("O simulado já começou 😉");
        let router = this.$router;
        setTimeout((router) => {
          router.push({ name: "event.mocks.start" });
        }, 1000);
      }

      this.mock = resp.data;
      this.timeLeft = resp.data.left * 60;

      if (this.$route.params.id === "new") {
        this.mock.mode = parseInt(this.$route.query.mode);
      }
      if (!isNaN(this.$route.params.id)) {
        this.mock.mode = 2; // Its a Mock like CPA-10, 20, CEA etc...
      }
      this.questions = resp.data.questions.data;
      this.totalQuestions = this.questions.length;
      this.mapQuestions(resp.data.questions.data);
      this.currentQuestion = 1;
      this.loading = false;
    });
    if (!this.authenticated) {
      window.getApp.sendSnackMessage(
        "Você precisa estar logado para corrigir as questões 😉",
      );
    }
  },
  methods: {
    changeQuestions(newQuestions) {
      this.loading = true;
      this.questions = newQuestions;
      this.totalQuestions = this.questions.length;
      this.currentQuestion = 1;
      this.loading = false;
    },
    isAuth() {
      if (!this.authenticated) {
        window.getApp.sendSnackMessage(
          "Você precisa estar logado para corrigir as questões 😉",
        );
        return false;
      } else return true;
    },
    finishMock(ignoreBlanks = false) {
      if (!this.authenticated) {
        window.getApp.sendSnackMessage(
          "Você precisa estar logado para corrigir as questões 😉",
        );
        return;
      }
      this.dialog = false;
      const res = this.existBlanks();
      // console.log(ignoreBlanks, res)
      if (!ignoreBlanks && res) {
        this.dialog = true;
        return;
      }
      this.loading = true;
      const answers = this.questions.map((elem) => {
        return { id: elem.id, answer: elem.answer };
      });
      // console.log(answers)
      MockService.checkResult(
        this.mock.mock_log_id,
        answers,
        this.mock.id,
      ).then((resp) => {
        console.log("finalizando simukado: ", this.mock);
        this.mockFinished = true;
        this.loading = false;
        this.$router.push({
          name: "event.mocks.finish",
          query: { p: this.mock.id },
        });
        // window.location = '/simulados/cfp-37/finalizado?p=' + this.mock.id
      });
    },
    thereAreQuestionsLeft() {
      const thereAre = this.questions.find((q) => {
        return q.finished !== true;
      });
      return !(thereAre === undefined);
    },
    existBlanks() {
      const blanks = this.questions.find((q) => {
        return q.answer == null;
      });
      return !(blanks === undefined);
    },
    mapQuestions(questionsArray) {
      this.questions = this.questions.map((item) => {
        const q = questionsArray.findIndex((q) => {
          return q.id === item.id;
        });
        // console.log('index encontrado: ', q)
        if (q > -1) {
          item.correct_answer = questionsArray[q].correct_answer;
          item.correct = questionsArray[q].correct;
          item.finished = item.correct !== undefined && item.correct !== null;
        } else {
          item.correct_answer = null;
          item.correct = null;
          item.finished = false;
        }
        return item;
      });
    },
    onTimeOver() {
      this.timeLeft = 0;
      this.finishMock(true);
    },
    onTimeUpdate(secondsLeft) {
      // console.log('TimeUpdate: ', secondsLeft)
      this.timeLeft = secondsLeft;
    },
  },
};
</script>
